import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import validator from '../../../lib/validators'

const TEXT = 'text'
const PHONE = 'tel'
const NUMBER = 'number'
const EMAIL = 'email'
const URL = 'url'
const PASSWORD = 'password'
const SELECT = 'select'

const TYPES = [TEXT, PHONE, NUMBER, EMAIL, URL, PASSWORD, SELECT]

const VALIDATORS = ['required', 'max', 'maxLength', 'min', 'minLength', 'pattern']

export default function(WrappedComponent) {
  return class extends Component {
    static propTypes = {
      model: PropTypes.shape({
        name: PropTypes.string.isRequired,
        type: PropTypes.oneOf(TYPES),
        value: PropTypes.any.isRequired,
      }),
      name: PropTypes.string,
      type: PropTypes.oneOf(TYPES),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      className: PropTypes.string,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func,
      onChange: PropTypes.func,
      required: PropTypes.bool,
      max: PropTypes.number,
      maxLength: PropTypes.number,
      min: PropTypes.number,
      minLength: PropTypes.number,
      pattern: PropTypes.string,
      size: PropTypes.string,
      invalid: PropTypes.bool,
      mask: PropTypes.array,
    }

    state = {
      name: null,
      type: 'text',
      value: null,
      valid: undefined,
      invalid: false,
      dirty: false,
      pristine: true,
      touched: false,
      untouched: true,
      pending: false,
      error: {},
    }

    get name() {
      if (this.props.model) {
        return this.props.model.name
      }
      return this.props.name
    }

    get value() {
      if (this.props.model) {
        return this.props.model.value
      }
      return this.props.value
    }

    UNSAFE_componentWillMount() {
      let { name, type, value } = this.props
      const { model, required, max, maxLength, min, minLength, pattern } = this.props

      if (model !== undefined) {
        name = model.name
        type = model.type
        value = model.value
      }

      const validators = validator(type)

      validators.required = required
      validators.max = max
      validators.maxLength = maxLength
      validators.min = min
      validators.minLength = minLength
      validators.pattern = pattern

      this.validators = validators

      const result = this.runValidators(this.value)

      this.setState(
        (state) => ({
          ...state,
          name,
          type,
          value,
          ...result,
        }),
        () => {
          if (this.props.onChange) {
            this.props.onChange(undefined, this.state)
          }
        },
      )
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      VALIDATORS.forEach((key) => {
        if (this.props[key] !== nextProps[key]) {
          this.validators[key] = nextProps[key]
        }
      })

      const nextValue = nextProps.model ? nextProps.model.value : nextProps.value
      if (nextValue !== this.state.value) {
        this.setState((state) => ({
          ...state,
          value: nextValue,
        }))
      }
    }

    validators = {}
    runValidators = (value = this.value) => {
      const { callback, ...result } = this.validators.run(value)

      if (callback) {
        callback((resultValidator) => {
          this.setState(
            (state) => ({
              ...state,
              ...resultValidator,
              pending: false,
            }),
            () => {
              if (this.props.onChange) {
                this.props.onChange(undefined, this.state)
              }
            },
          )
        })
      }
      return { ...result }
    }

    onFocus = () => {
      const nextState = {
        touched: true,
        untouched: false,
      }

      if (this.state.pristine === true) {
        nextState.dirty = true
        nextState.pristine = false
      }

      this.setState(
        (state) => ({
          ...state,
          ...nextState,
        }),
        () => {
          if (this.props.onFocus) {
            this.props.onFocus(event, this.state)
          } else if (this.props.onChange) {
            this.props.onChange(null, this.state)
          }
        },
      )
    }

    onBlur = (event) => {
      const resultValidator = this.runValidators()

      this.setState(
        (state) => ({
          ...state,
          touched: false,
          untouched: true,
          ...resultValidator,
        }),
        () => {
          if (this.props.onBlur) {
            this.props.onBlur(event, this.state)
          } else if (this.props.onChange) {
            this.props.onChange(null, this.state)
          }
        },
      )
    }

    onChange = (event) => {
      const value = event.target.value
      const resultValidator = this.runValidators(value)

      this.setState(
        (state) => ({
          ...state,
          ...resultValidator,
          value,
        }),
        () => {
          if (this.props.onChange) {
            this.props.onChange(event, this.state)
          }
        },
      )
    }

    render() {
      let { name, type } = this.props

      const { model, className, ...others } = this.props

      if (model !== undefined) {
        name = model.name
        type = model.type
      }

      if (type === SELECT) {
        others.options = model.options
      }

      const { dirty, pristine, touched, untouched, valid, invalid, pending, value } = this.state

      const componentClass = cx({
        dirty,
        pristine,
        pending,
        valid: dirty && valid,
        invalid: dirty && invalid,
        touched: dirty && touched,
        untouched: dirty && untouched,
        [className]: className,
      })

      const component = (
        <WrappedComponent
          {...others}
          name={name}
          type={type}
          value={value}
          className={componentClass}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
      )

      return component
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/HOC/Input.js